import { useState } from 'react';
import { testimonials } from '@/mocks/categories';

const AVATAR_T1 = "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20confident%20businessman%20in%20his%20thirties%20wearing%20a%20crisp%20white%20shirt%2C%20warm%20studio%20lighting%2C%20clean%20cream%20background%2C%20friendly%20professional%20expression&width=120&height=120&seq=test-av1-v3-2026x&orientation=squarish";
const AVATAR_T2 = "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20elegant%20woman%20in%20her%20thirties%20with%20minimal%20makeup%2C%20soft%20window%20light%2C%20warm%20neutral%20background%2C%20genuine%20approachable%20smile%2C%20editorial%20portrait&width=120&height=120&seq=test-av2-v3-2026x&orientation=squarish";
const AVATAR_T3 = "https://readdy.ai/api/search-image?query=Headshot%20portrait%20of%20a%20trendy%20young%20professional%20man%20with%20a%20beard%2C%20natural%20afternoon%20light%2C%20clean%20beige%20background%2C%20relaxed%20confident%20expression%2C%20editorial%20photography&width=120&height=120&seq=test-av3-v3-2026x&orientation=squarish";

const AVATARS = [AVATAR_T1, AVATAR_T2, AVATAR_T3];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-16 md:py-24 bg-secondary-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-10">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-foreground-950 text-2xl md:text-[2.5rem] font-heading font-bold leading-tight">
              <span className="text-foreground-400">&ldquo;</span>Trusted by Real Buyers<span className="text-foreground-400">&rdquo;</span>
            </h2>
          </div>

          <div className="relative bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
            <div className="flex items-start gap-2 mb-6">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                4.9
              </span>
            </div>

            <blockquote className="text-foreground-700 text-lg md:text-xl leading-relaxed font-heading italic mb-8">
              &ldquo;{t.quote}&rdquo;
            </blockquote>

            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
                <img src={AVATARS[current]} alt={t.name} className="w-full h-full object-cover" />
              </div>
              <div>
                <div className="text-foreground-950 font-semibold text-sm">{t.name}</div>
                <div className="text-foreground-400 text-xs">{t.email}</div>
              </div>
            </div>

            <div className="absolute bottom-6 right-6 flex items-center gap-2">
              <button
                onClick={prev}
                className="w-10 h-10 rounded-full border-2 border-foreground-200 flex items-center justify-center cursor-pointer hover:border-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-all"
              >
                <i className="ri-arrow-left-line text-lg"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 rounded-full bg-foreground-950 text-background-50 flex items-center justify-center cursor-pointer hover:bg-foreground-800 transition-all"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}